import React from 'react';
import Tooltip from "@/shared/ui/Tooltip";

type ProgressBarProps = {
  progress: number;
  barColor?: string;
  progressColor?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
};

const ProgressBar: React.FC<ProgressBarProps> = ({
     progress,
     barColor = "rgba(255, 255, 255, 0.16)",
     progressColor = "#FF9500",
     width = 32,
     height = 33,
     strokeWidth = 6,
   }) => {
  const radius = (width - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progressOffset = circumference - (progress / 100) * circumference;

  return (
    <Tooltip ToggleComponent={
      <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height}>
        <circle
          cx={width / 2}
          cy={height / 2}
          r={radius}
          fill="none"
          stroke={barColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={width / 2}
          cy={height / 2}
          r={radius}
          fill="none"
          stroke={progressColor}
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={progressOffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${width/2} ${height/2})`}
        />
      </svg>
    }>
      {progress} %
    </Tooltip>
  );
};

export default ProgressBar;
